// @ts-strict-ignore
import React from 'react'
import { IonLabel, IonRow, IonSegment, IonSegmentButton } from '@ionic/react'

import './styles/segmentButtons.less'

interface Props {
	onChange: (value: string) => void
	selectedValue: string
	buttons: {
		value: string
		label: string
	}[]
}

const SegmentButtons = ({ onChange, selectedValue, buttons }: Props): JSX.Element => (
	<IonRow className="segment-controls-container">
		<div className="segment-controls-row">
			<IonSegment onIonChange={e => onChange(e.detail.value)} value={selectedValue} mode="ios">
				{buttons.map(({ value, label }) => (
					<IonSegmentButton key={value} value={value} mode="ios">
						<IonLabel>{label}</IonLabel>
					</IonSegmentButton>
				))}
			</IonSegment>
		</div>
	</IonRow>
)

export default SegmentButtons
